import apiEndPoints from '../utils/ctxUtil';
import { adalApiFetch } from '../adalConfig';

export function uploadSuccess(bool = false) {
  return {
    type: 'UPLOAD_DOCUMENT_SUCCESS',
    isUploaded: bool,
  };
}

export function uploadFail(error) {
  return {
    type: 'UPLOAD_DOCUMENT_FAIL',
    error: error?.message || error.toString(), // Store only the message
  };
}

export function fileIsUploading(bool = false) {
  return {
    type: 'UPLOAD_DOCUMENT_UPLOADING',
    isUploading: bool,
  };
}

export function cafOfferListHasErrored(bool) {
  return {
    type: 'CAF_LIST_HAS_ERRORED',
    hasErrored: bool,
  };
}

export function cafOfferListIsLoading(bool) {
  return {
    type: 'CAF_LIST_IS_LOADING',
    isLoading: bool,
  };
}

export function cafListFetchDataSuccess(cafOfferList) {
  return {
    type: 'CAF_LIST_FETCH_DATA_SUCCESS',
    cafOfferList,
  };
}

export function clearCafListData() {
  return {
    type: 'CLEAR_CAF_LIST_DATA',
  };
}

export function cafHistoryListHasErrored(bool) {
  return {
    type: 'CAF_HISTORY_LIST_HAS_ERRORED',
    hasErrored: bool,
  };
}

export function cafHistoryListIsLoading(bool) {
  return {
    type: 'CAF_HISTORY_LIST_IS_LOADING',
    isLoading: bool,
  };
}

export function cafHistoryListFetchDataSuccess(items) {
  return {
    type: 'CAF_HISTORY_LIST_FETCH_DATA_SUCCESS',
    items,
  };
}

export function purchaseRebateCafListHasErrored(bool) {
  return {
    type: 'PURCHASE_REBATE_CAF_LIST_HAS_ERRORED',
    hasErrored: bool,
  };
}

export function uploadDocumentRequest(
  file,
  rebateName,
  name,
  offerId,
  fileId,
  effDate,
  rebateType,
  purchaseType,
) {
  const data = new FormData();
  data.append('file', file);
  data.append('rebateName', rebateName);
  data.append('name', name);
  data.append('offerId', offerId);
  data.append('fileId', fileId);
  data.append('effectiveDate', effDate);
  data.append('rebateType', rebateType);
  data.append('purchaseType', purchaseType);
  const url = apiEndPoints.OFFER_CAF_FILE_UPLOAD;

  return (dispatch) => {
    dispatch(fileIsUploading(true));
    dispatch(cafListFetchDataSuccess([]));
    adalApiFetch(fetch, url, {
      method: 'POST',
      body: data,
    })
      .then((response) => {
        dispatch(fileIsUploading(false));
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(uploadSuccess(true));
      })
      .catch((error) => {
        dispatch(fileIsUploading(false));
        dispatch(uploadFail(error));
        dispatch(uploadSuccess(false));
        dispatch(cafOfferListHasErrored(true));
      });
  };
}

export function cafOfferListFetchData(fileId) {
  const url = apiEndPoints.OFFER_CAF_FILE.replace('fileId', fileId);
  return (dispatch) => {
    dispatch(uploadSuccess(false));
    adalApiFetch(fetch, url, {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        'cache-control': 'no-cache',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((cafOfferList) => dispatch(cafListFetchDataSuccess(cafOfferList)))
      .catch(() => {
        dispatch(cafOfferListHasErrored(true));
      });
  };
}

export function cafListFetchData(fileId) {
  const url = apiEndPoints.OFFER_CAF_FILE_LIST.replace('fileId', fileId);
  return (dispatch) => {
    dispatch(uploadSuccess(false));
    dispatch(cafHistoryListIsLoading(false));
    adalApiFetch(fetch, url, {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        'cache-control': 'no-cache',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((items) => dispatch(cafHistoryListFetchDataSuccess(items)))
      .catch(() => {
        dispatch(cafHistoryListHasErrored(true));
        dispatch(cafHistoryListIsLoading(false));
      });
  };
}

export function purchaseRebateCafListFetchData() {
  const url = apiEndPoints.PURCHASE_REBATE_CAF_LIST;
  return (dispatch) => {
    dispatch(cafHistoryListIsLoading(true));
    dispatch(uploadSuccess(false));
    adalApiFetch(fetch, url, {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        'cache-control': 'no-cache',
      },
    })
      .then((response) => {
        dispatch(cafHistoryListIsLoading(false));
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((items) => dispatch(cafHistoryListFetchDataSuccess(items)))
      .catch(() => {
        dispatch(cafHistoryListHasErrored(true));
        dispatch(cafHistoryListIsLoading(false));
      });
  };
}
